import { render, staticRenderFns } from "./LikeIcon.vue?vue&type=template&id=1c89a113&scoped=true&"
import script from "./LikeIcon.vue?vue&type=script&lang=js&"
export * from "./LikeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c89a113",
  null
  
)

export default component.exports